export const FilterList = (props) => {
    return (
<svg xmlns="http://www.w3.org/2000/svg" width="18" height="11" viewBox="0 0 18 11" fill="none">
<path d="M7 10.4937V8.74979H11V10.4937H7ZM3 6.13393V4.39003H15V6.13393H3ZM0 1.77418V0.0302734H18V1.77418H0Z" fill="#868585"/>
</svg>)
}